/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ../~/lodash/fp/placeholder.js
// module id = 227
// module chunks = 0